var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "whatsapp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_21",
    "data-name": "Rect\\xE1ngulo 21",
    width: 24,
    height: 24,
    fill: "#1c1c1c",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M0,20.1v0l1.412-5.158a9.957,9.957,0,1,1,3.866,3.775L0,20.1Zm5.826-3.008a8.28,8.28,0,1,0-2.8-2.725l.2.313L2.391,17.73l3.132-.822ZM11.667,14.6a14.511,14.511,0,0,1-1.418-.525A11.094,11.094,0,0,1,6,10.32,4.846,4.846,0,0,1,4.982,7.746,2.793,2.793,0,0,1,5.853,5.67a.913.913,0,0,1,.663-.311c.167,0,.332,0,.477.009h.056c.145,0,.326,0,.5.427.208.5.7,1.723.768,1.847a.46.46,0,0,1,.021.437,1.73,1.73,0,0,1-.249.415c-.124.145-.261.324-.373.436s-.254.259-.109.509a7.5,7.5,0,0,0,1.384,1.724A6.777,6.777,0,0,0,11,12.4c.248.124.393.1.538-.062s.623-.727.788-.976.332-.208.56-.125,1.452.685,1.7.81.415.186.477.291a2.084,2.084,0,0,1-.145,1.184A2.564,2.564,0,0,1,13.234,14.7a4.1,4.1,0,0,1-.605.048A3.164,3.164,0,0,1,11.667,14.6Z",
    transform: "translate(2 2)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.413b226bd304cc45979b1e0faeca9c15.svg";
export { ForwardRef as ReactComponent };